import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import { FormError } from '../form/FormError';
import { FormTextarea } from '../form/FormTextarea';
import { ConfirmAnalysisModal } from '~/components/patientReports/ConfirmAnalysisModal';
import { ConfirmInPersonAnalysisModal } from '~/components/patientReports/ConfirmInPersonAnalysisModal';
import { CheckOutlined, ContentCopyOutlined, } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { AddTimeModal } from '~/components/patientReports/AddTimeModal';
import { getUsersForPractice } from "~/api/settings/getUsersForPractice";
import { PastNotes } from "~/components/patientReports/PastNotes/PastNotes";
import { PastReportView } from "~/components/patientReports/PastNotes/PastReportView";
import ButtonGroup from "@mui/material/ButtonGroup";
import ReviewTypeSelector from "~/components/patientReports/ReviewTypeSelector";
import OtherTypeSelector from "~/components/patientReports/OtherTypeSelector";
import { DotPhraseMenu } from "~/components/dotPhrases/DotPhraseMenu";
import { getDotPhrasesRequest } from "~/api/dotPhrases/getDotPhrasesRequest";
const onCopy = () => {
    toast.success('Text has been copied to clipboard.');
};
export const PhysicianDocumentationForm = (props) => {
    const { patient, patientReport, notes, noConsentOptionsDisabled, draftSensorReview, onSensorReviewChange } = props;
    const [selectedReviewMethod, setSelectedReviewMethod] = useState('data-analysis');
    const methods = useForm({
        defaultValues: {
            sensorReview: '',
            reviewType: 'remote',
            otherType: noConsentOptionsDisabled ? 'non-billable' : 'follow-up',
            offlineReview: true
        }
    });
    const { formState: { isSubmitting, errors }, handleSubmit, register, watch, setValue, getValues } = methods;
    useEffect(() => {
        if (patientReport) {
            setValue('sensorReview', draftSensorReview);
            setValue('reviewType', 'remote');
            setValue('offlineReview', true);
        }
        else {
            setValue('sensorReview', draftSensorReview);
            setValue('reviewType', 'remote');
            setValue('offlineReview', true);
        }
        if (!patient.cgmConsent) {
            setSelectedReviewMethod('other');
        }
    }, [patientReport]);
    // const { mutateAsync } = usePatientReportMutation();
    const sensorReview = watch('sensorReview');
    const onSubmit = (data) => {
        console.log('inside of on submit');
        // if(data.reviewType === 'in-person') {
        //
        //   setAreYouSureOpen(true);
        //
        // } else {
        //   // show time tracking modal
        //   setOpen(true);
        // }
    };
    const confirmClicked = (data) => {
        console.log('Data: ');
        console.log(data);
        if (data.reviewType === 'in-person') {
            setAreYouSureOpen(true);
        }
        else {
            // show time tracking modal
            setOpen(true);
        }
    };
    const [isOpen, setOpen] = useState(false);
    const [isAreYouSureOpen, setAreYouSureOpen] = useState(false);
    const [isAddTimeOpen, setIsAddTimeOpen] = useState(false);
    const [providers, setProviders] = useState([]);
    const [isShowPastNotesOpen, setShowPastNotesOpen] = useState(false);
    const [isShowPastReportOpen, setShowPastReportOpen] = useState(false);
    const [pastReportId, setPastReportId] = useState('');
    const [isDotPhraseMenuOpen, setIsDotPhraseMenuOpen] = useState(false);
    const [dotPhraseAnchorEl, setDotPhraseAnchorEl] = useState(null);
    const [dotPosition, setDotPosition] = useState(0);
    const [dotPhrases, setDotPhrases] = useState([]);
    useEffect(() => {
        fetchPracticeUsers();
    }, []);
    const fetchPracticeUsers = async () => {
        const { users } = await getUsersForPractice();
        console.log('Practice users:');
        console.log(users);
        const providerFullNames = [];
        users.map((user) => {
            if (user.personalInfo.roleId == 3) {
                const fullname = user.personalInfo.firstname + ' ' + user.personalInfo.lastname;
                providerFullNames.push(fullname);
            }
        });
        setProviders(providerFullNames);
    };
    const submitClicked = () => {
        if (selectedReviewMethod === 'data-analysis') {
            confirmClicked(methods.getValues());
        }
        if (selectedReviewMethod === 'other') {
            setIsAddTimeOpen(true);
        }
    };
    const handleInput = (e) => {
        const value = e.target.value;
        const cursorPosition = e.target.selectionStart;
        // Check if cursor is right after a dot
        if (cursorPosition > 0 && value[cursorPosition - 1] === '.') {
            setDotPhraseAnchorEl(e.target); // Use the event target as anchor
            setIsDotPhraseMenuOpen(true);
            setDotPosition(cursorPosition - 1);
        }
        else {
            setIsDotPhraseMenuOpen(false);
            setDotPhraseAnchorEl(null); // Use the event target as anchor
        }
        onSensorReviewChange(value);
    };
    useEffect(() => {
        getDotPhrases();
    }, []);
    const getDotPhrases = async () => {
        const dotPhrases = await getDotPhrasesRequest();
        setDotPhrases(dotPhrases.dotPhrases);
    };
    return (React.createElement(FormProvider, { ...methods },
        React.createElement("form", { onSubmit: handleSubmit(onSubmit) },
            React.createElement("div", { className: "bg-white rounded-lg p-5" },
                React.createElement("div", { className: 'flex' },
                    React.createElement("h3", { className: "text-black text-xl mb-4 mr-2", style: { fontFamily: 'Barlow' } }, "Activity:"),
                    React.createElement("div", { className: "inline-flex focus-within:ring-2", style: { height: '30px', background: '#286CD4', borderRadius: 6 } },
                        React.createElement(ButtonGroup, { color: 'primary', variant: 'contained' },
                            React.createElement(Button, { style: { fontWeight: 900, borderTopRightRadius: 6, borderBottomRightRadius: 6 }, size: 'small', variant: 'contained', color: selectedReviewMethod === 'data-analysis' ? 'primary' : 'inherit', id: "review-type-data", value: "data-analysis", disabled: noConsentOptionsDisabled, onClick: () => {
                                    setSelectedReviewMethod('data-analysis');
                                    console.log('setting data-analysis');
                                }, sx: {
                                    '&.Mui-disabled': {
                                        backgroundColor: '#e0e0e0',
                                        color: '#bbbbbb',
                                        borderColor: 'divider',
                                    }
                                } }, "Data Analysis"),
                            React.createElement(Button, { style: { fontWeight: 900, borderTopLeftRadius: 6, borderBottomLeftRadius: 6 }, size: 'small', color: selectedReviewMethod === 'other' ? 'primary' : 'inherit', variant: 'contained', id: "review-type-other", value: "other", onClick: () => {
                                    setSelectedReviewMethod('other');
                                }, sx: {
                                    '&.Mui-disabled': {
                                        backgroundColor: '#e0e0e0',
                                        color: '#bbbbbb',
                                        borderColor: 'divider',
                                    }
                                } }, "Other"))),
                    React.createElement("div", { style: {
                            display: 'none',
                            marginLeft: 'auto',
                            float: 'right',
                            color: '#2C78EB',
                            fontWeight: 600,
                            fontSize: 17,
                            fontFamily: 'Barlow',
                            cursor: 'pointer'
                        }, onClick: () => setShowPastNotesOpen(true) }, "View Past Notes")),
                isShowPastNotesOpen && (React.createElement(PastNotes, { isReportOpen: isShowPastReportOpen, patient: patient, notes: notes, onClose: () => setShowPastNotesOpen(false), reportClicked: (reportId) => {
                        setPastReportId(reportId);
                        setShowPastReportOpen(true);
                    } })),
                isShowPastReportOpen && (React.createElement(PastReportView, { reportId: pastReportId, onClose: () => setShowPastReportOpen(false) })),
                selectedReviewMethod === 'data-analysis' && React.createElement(ReviewTypeSelector, { value: 'remote', onChange: (value) => setValue('reviewType', value) }),
                selectedReviewMethod === 'other' && React.createElement(OtherTypeSelector, { noConsentOptionsDisabled: noConsentOptionsDisabled, value: noConsentOptionsDisabled ? 'non-billable' : 'follow-up', onChange: (value) => {
                        setValue('reviewType', 'remote');
                        console.log('setting value: ');
                        console.log(value);
                        setValue('otherType', value);
                    } }),
                React.createElement("div", null,
                    React.createElement("label", { htmlFor: "sensor-review", className: "sr-only" }, "Glucose Sensor Review"),
                    React.createElement("div", { style: { position: 'relative' } },
                        React.createElement(FormTextarea, { ...register('sensorReview', {
                                required: 'Sensor review is required',
                            }), id: "sensor-review", cols: 72, rows: 16, className: "w-full", onInput: handleInput }),
                        isDotPhraseMenuOpen &&
                            React.createElement(DotPhraseMenu, { practiceId: patient?.practiceId ? patient.practiceId : '', userId: '1', anchorEl: dotPhraseAnchorEl, dotPosition: dotPosition, initialDotPhrases: dotPhrases, dotPhraseSelected: (content) => {
                                    const currentValue = getValues('sensorReview');
                                    // Remove the dot and insert the content at that position
                                    const beforeDot = currentValue.slice(0, dotPosition);
                                    const afterDot = currentValue.slice(dotPosition + 1);
                                    const newValue = beforeDot + content + afterDot;
                                    setValue('sensorReview', newValue);
                                } }),
                        React.createElement("div", { className: "flex justify-between relative", style: { bottom: '45px', right: '10px' } },
                            React.createElement(FormError, { errors: errors, name: "sensorReview" }),
                            React.createElement("div", { className: "ml-auto" },
                                React.createElement(CopyToClipboard, { text: sensorReview, onCopy: onCopy },
                                    React.createElement(Button, { variant: 'contained', size: 'small', startIcon: React.createElement(ContentCopyOutlined, null), style: { color: 'white', backgroundColor: '#018FB7', fontWeight: 700 } }, "Copy")))))),
                React.createElement("div", { className: 'inline-flex w-full', style: { marginTop: '-35px' } },
                    React.createElement(Button, { style: { width: '100%' }, size: 'medium', color: 'primary', variant: 'contained', startIcon: React.createElement(CheckOutlined, null), onClick: () => submitClicked() }, isSubmitting ? 'Submitting...' : 'Submit'),
                    isOpen && (React.createElement(ConfirmAnalysisModal, { onRequestClose: () => setOpen(false), reportID: patientReport.id, sensorReview: sensorReview, providerNames: providers, followUpDate: patient.followUp, patientId: patient.id, patient: patient })),
                    isAreYouSureOpen && (React.createElement(ConfirmInPersonAnalysisModal, { onRequestClose: () => { setAreYouSureOpen(false); setOpen(false); }, reportID: patientReport.id, sensorReview: sensorReview, providerNames: providers, followUpDate: patient.followUp, patientId: patient.id, patient: patient })),
                    isAddTimeOpen && (React.createElement(AddTimeModal, { onRequestClose: () => { setIsAddTimeOpen(false); setAreYouSureOpen(false); setOpen(false); }, reportID: patientReport ? patientReport.id : 'null', sensorReview: sensorReview, patientId: patient.id, reviewType: methods.getValues('reviewType'), followUpDate: patient.followUp, otherType: methods.getValues('otherType'), patient: patient })))))));
};
